import { render } from "./AppNavbarActions.vue?vue&type=template&id=55ff667e"
import script from "./AppNavbarActions.vue?vue&type=script&lang=js"
export * from "./AppNavbarActions.vue?vue&type=script&lang=js"

import "./AppNavbarActions.vue?vue&type=style&index=0&id=55ff667e&lang=scss"

import exportComponent from "/home/admin/dimensional-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__